@if (actions && actions.length > 0) {
  <menu class="actions-button-container" [matMenuTriggerFor]="menu">
    <img
      src="assets/images/common/dots.svg"
      class="actions-button"
      [ngClass]="{ 'actions-button-small': smallSize }"
      alt="actions"
    />
  </menu>
  <mat-menu #menu="matMenu">
    <div
      *ngFor="let action of actions"
      [matTooltip]="action.tooltip ? action.tooltip : ''"
      matTooltipPosition="left"
      matTooltipClass="tooltip-container"
    >
      <button mat-menu-item (click)="onClick(action)" [disabled]="action.disabled">
        {{ action.displayNameLabel | labelsProvider }}
      </button>
    </div>
  </mat-menu>
}
